(function () {
  const ROOT_SEL = "[data-upsell-root]";
  const TRACK_SEL = "[data-upsell-track]";
  const PREV_SEL = "[data-upsell-prev]";
  const NEXT_SEL = "[data-upsell-next]";
  const SLIDE_SEL = ".m-cart-drawer-upsell__slide";

  const SCROLL_END_DEBOUNCE = 140;

  // re-init tries after cart refresh (drawer rerender timing)
  const REINIT_TRIES = 8;
  const REINIT_DELAY = 120;

  function q(root, sel) {
    return root ? root.querySelector(sel) : null;
  }
  function qa(root, sel) {
    return root ? Array.from(root.querySelectorAll(sel)) : [];
  }

  function getGap(track) {
    const gap = parseFloat(getComputedStyle(track).gap || "0");
    return Number.isFinite(gap) ? gap : 0;
  }

  function getStep(track) {
    const slide = track.querySelector(SLIDE_SEL);
    if (!slide) return 0;
    return slide.getBoundingClientRect().width + getGap(track);
  }

  function setScrollBehavior(track, value) {
    track.style.scrollBehavior = value;
  }

  function goToIndex(track, idx, smooth) {
    const step = track.__upsellStep || getStep(track);
    if (!step) return;

    setScrollBehavior(track, smooth ? "smooth" : "auto");
    track.scrollLeft = idx * step;
  }

  function getNearestIndex(track) {
    const step = track.__upsellStep || getStep(track);
    if (!step) return 0;
    return Math.round(track.scrollLeft / step);
  }

  function afterScrollEnd(track, cb) {
    if ("onscrollend" in document) {
      const onEnd = () => {
        track.removeEventListener("scrollend", onEnd);
        cb();
      };
      track.addEventListener("scrollend", onEnd, { once: true });
      return;
    }

    clearTimeout(track.__upsellScrollEndTimer);

    const onScroll = () => {
      clearTimeout(track.__upsellScrollEndTimer);
      track.__upsellScrollEndTimer = setTimeout(() => {
        track.removeEventListener("scroll", onScroll);
        cb();
      }, SCROLL_END_DEBOUNCE);
    };

    track.addEventListener("scroll", onScroll);

    track.__upsellScrollEndTimer = setTimeout(() => {
      track.removeEventListener("scroll", onScroll);
      cb();
    }, 600);
  }

  function normalizeIfOnClone(track) {
    const n = track.__upsellRealCount;
    if (!n) return;

    const idx = getNearestIndex(track);
    // 0 = lastClone
    // 1..n = real
    // n+1 = firstClone
    if (idx === 0) {
      goToIndex(track, n, false);
    } else if (idx === n + 1) {
      goToIndex(track, 1, false);
    }
  }

  function removeClones(track) {
    qa(track, `${SLIDE_SEL}[data-clone="1"]`).forEach((el) => el.remove());
  }

  function bindScrollOnce(track) {
  if (track.__upsellScrollBound) return;
  track.__upsellScrollBound = true;

  track.addEventListener("scroll", () => {
    // mark active interaction (prevents rebuild while swiping)
    track.__upsellIsScrolling = true;
    clearTimeout(track.__upsellIsScrollingTimer);
    track.__upsellIsScrollingTimer = setTimeout(() => {
      track.__upsellIsScrolling = false;
    }, 180);

    if (track.__upsellLock) return;

    clearTimeout(track.__upsellNormalizeTimer);
    track.__upsellNormalizeTimer = setTimeout(() => {
      normalizeIfOnClone(track);
    }, 80);
  });
}

  function getRealSlides(track) {
    return qa(track, `${SLIDE_SEL}:not([data-clone="1"])`);
  }

  // idempotent track setup: safe to call multiple times
function hasTwoClones(track) {
  return qa(track, `${SLIDE_SEL}[data-clone="1"]`).length === 2;
}

function setupTrack(track) {
  if (!track) return;

  const realSlides = getRealSlides(track);

  // якщо ще нема нормального контенту — не інітимо
  if (realSlides.length < 2) {
    track.__upsellRealCount = realSlides.length || 0;
    track.__upsellStep = 0;
    return;
  }

  // Якщо трек уже зібраний, кількість збігається і є 2 клони —
  // НЕ чіпаємо DOM (це ключ до відсутності фризів).
  if (
    track.__upsellInited &&
    track.__upsellRealCount === realSlides.length &&
    hasTwoClones(track)
  ) {
    // тільки оновимо step (на випадок зміни ширини)
    track.__upsellStep = getStep(track);
    bindScrollOnce(track);
    return;
  }

  // Інакше — робимо повну (але одноразову) збірку
  removeClones(track);

  track.__upsellInited = true;
  track.__upsellRealCount = realSlides.length;

  const firstClone = realSlides[0].cloneNode(true);
  const lastClone = realSlides[realSlides.length - 1].cloneNode(true);
  firstClone.dataset.clone = "1";
  lastClone.dataset.clone = "1";

  track.insertBefore(lastClone, track.firstChild);
  track.appendChild(firstClone);

  requestAnimationFrame(() => {
    track.__upsellStep = getStep(track);
    goToIndex(track, 1, false);
    setScrollBehavior(track, "smooth");
  });

  bindScrollOnce(track);
}

  // =========================
  // NYX dropdown (select-driven)
  // =========================
  function isMobileDropdown() {
    return (
      window.matchMedia("(max-width: 768px)").matches ||
      window.matchMedia("(pointer: coarse)").matches
    );
  }

  function buildUpsellDropdown(ddRoot) {
    const select = ddRoot.querySelector("[data-upsell-variant-select]");
    const panel = ddRoot.querySelector("[data-upsell-dd-panel]");
    const trigger = ddRoot.querySelector("[data-upsell-dd-trigger]");
    const chip = ddRoot.querySelector("[data-upsell-dd-chip]");
    const name = ddRoot.querySelector("[data-upsell-dd-name]");
    if (!select || !panel || !trigger || !chip || !name) return;

    const getSwatch = (opt) =>
      opt.getAttribute("data-swatch") || opt.getAttribute("data-image") || "";

    // якщо select той самий і панель уже побудована — не перебудовуємо
    const selectUnchanged = ddRoot.__ddSelectRef === select;
    const panelHasItems = panel.children && panel.children.length > 0;

    if (selectUnchanged && panelHasItems && ddRoot.__ddAbort) {
      const opt = select.options[select.selectedIndex];
      if (opt) {
        chip.style.backgroundImage = `url('${getSwatch(opt)}')`;
        name.textContent = (opt.textContent || "").trim();
      }
      return;
    }

    // select замінили (ререндер) або panel порожній → rebuild
    ddRoot.__ddSelectRef = select;

    // abort old listeners for this dropdown
    if (ddRoot.__ddAbort) {
      try {
        ddRoot.__ddAbort.abort();
      } catch (_) {}
    }
    ddRoot.__ddAbort = new AbortController();
    const { signal } = ddRoot.__ddAbort;

    // portal state (persist)
    const portalState =
      ddRoot.__ddPortalState ||
      (ddRoot.__ddPortalState = {
        backdrop: null,
        originalParent: null,
        originalNext: null,
      });

    function ensurePortalStateSaved() {
      if (!portalState.originalParent) {
        portalState.originalParent = panel.parentNode;
        portalState.originalNext = panel.nextSibling;
      }
    }

    function unmountPortal() {
      if (portalState.backdrop && portalState.backdrop.parentNode) {
        portalState.backdrop.parentNode.removeChild(portalState.backdrop);
      }

      if (portalState.originalParent) {
        panel.classList.remove("is-portal");
        panel.style.left = "";
        panel.style.width = "";
        panel.style.top = "";
        panel.style.bottom = "";
        panel.style.maxHeight = "";
        portalState.originalParent.insertBefore(panel, portalState.originalNext);
      }
    }

    function close() {
      ddRoot.setAttribute("aria-expanded", "false");
      unmountPortal();
    }

    function updatePortalPlacement() {
      const rect = trigger.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const vh = window.innerHeight || document.documentElement.clientHeight;

      const GAP = 12;
      const OFFSET = 8;
      const MIN_PANEL = 140;

      const spaceBelow = vh - rect.bottom - GAP;
      const spaceAbove = rect.top - GAP;
      const openTop = spaceBelow < MIN_PANEL && spaceAbove > spaceBelow;

      const left = GAP;
      const width = Math.max(280, vw - GAP * 2);

      panel.style.left = left + "px";
      panel.style.width = width + "px";

      const available = Math.max(120, (openTop ? spaceAbove : spaceBelow) - OFFSET);
      panel.style.maxHeight = available + "px";

      if (openTop) {
        panel.style.top = "";
        panel.style.bottom = vh - rect.top + OFFSET + "px";
      } else {
        panel.style.bottom = "";
        panel.style.top = rect.bottom + OFFSET + "px";
      }
    }

    function updateDesktopPlacement() {
      const rect = trigger.getBoundingClientRect();

      const card =
        ddRoot.closest(".m-cart-drawer-upsell__card") ||
        ddRoot.closest(".m-cart-drawer-upsell__slide") ||
        ddRoot;

      const cardRect = card.getBoundingClientRect();

      const GAP = 8;
      const OFFSET = 6;
      const MIN_PANEL = 120;

      const spaceBelow = cardRect.bottom - rect.bottom - GAP;
      const spaceAbove = rect.top - cardRect.top - GAP;

      const openTop = spaceBelow < MIN_PANEL && spaceAbove > spaceBelow;

      ddRoot.dataset.placement = openTop ? "top" : "bottom";

      const available = Math.max(100, (openTop ? spaceAbove : spaceBelow) - OFFSET);
      panel.style.maxHeight = available + "px";
    }

    function mountPortal() {
      ensurePortalStateSaved();

      if (!portalState.backdrop) {
        const bd = document.createElement("div");
        bd.className = "nyx-dd-backdrop";
        portalState.backdrop = bd;
      }

      // rebind click each rebuild via signal
      portalState.backdrop.addEventListener("click", close, { signal });

      document.body.appendChild(portalState.backdrop);
      document.body.appendChild(panel);
      panel.classList.add("is-portal");
    }

    function open() {
      if (isMobileDropdown()) {
        mountPortal();
        updatePortalPlacement();
        ddRoot.setAttribute("aria-expanded", "true");
        return;
      }

      unmountPortal(); // safety
      updateDesktopPlacement();
      ddRoot.setAttribute("aria-expanded", "true");
    }

    function toggle() {
      ddRoot.getAttribute("aria-expanded") === "true" ? close() : open();
    }

    // close before rebuild to avoid stuck portal
    close();

    // build list from select options
    panel.innerHTML = "";
    Array.from(select.options).forEach((opt, idx) => {
      const item = document.createElement("button");
      item.type = "button";
      item.className = "nyx-item";
      item.dataset.idx = String(idx);
      if (opt.disabled) item.disabled = true;

      const img = getSwatch(opt);
      const title = (opt.textContent || "").trim();

      item.innerHTML = `
        <span class="nyx-chip" style="background-image:url('${img}')"></span>
        <span class="nyx-name">${title}</span>
      `;

      item.addEventListener(
        "click",
        () => {
          if (item.disabled) return;
          select.selectedIndex = idx;
          close();
          select.dispatchEvent(new Event("change", { bubbles: true }));
        },
        { signal }
      );

      panel.appendChild(item);
    });

    function syncFromSelect() {
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      chip.style.backgroundImage = `url('${getSwatch(opt)}')`;
      name.textContent = (opt.textContent || "").trim();
    }

    syncFromSelect();
    select.addEventListener("change", syncFromSelect, { signal });

    trigger.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      },
      { signal }
    );

    // click outside
    document.addEventListener(
      "click",
      (e) => {
        if (!ddRoot.contains(e.target) && !panel.contains(e.target)) close();
      },
      { signal }
    );

    document.addEventListener(
      "keydown",
      (e) => {
        if (e.key === "Escape") close();
      },
      { signal }
    );

    window.addEventListener(
      "resize",
      () => {
        if (ddRoot.getAttribute("aria-expanded") !== "true") return;
        isMobileDropdown() ? updatePortalPlacement() : updateDesktopPlacement();
      },
      { signal }
    );

    window.addEventListener(
      "scroll",
      () => {
        if (ddRoot.getAttribute("aria-expanded") !== "true") return;
        isMobileDropdown() ? updatePortalPlacement() : updateDesktopPlacement();
      },
      { signal, capture: true }
    );
  }

  function initUpsellDropdowns() {
    document.querySelectorAll("[data-upsell-dd]").forEach(buildUpsellDropdown);
  }
  // =========================

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach((root) => {
      const track = q(root, TRACK_SEL);
      setupTrack(track);
    });
    initUpsellDropdowns();
  }

  function resetAllTracks() {
    document.querySelectorAll(ROOT_SEL).forEach((root) => {
      const track = q(root, TRACK_SEL);
      if (!track) return;

      removeClones(track);
      track.__upsellInited = false;
      track.__upsellRealCount = 0;
      track.__upsellStep = 0;

      clearTimeout(track.__upsellNormalizeTimer);
      clearTimeout(track.__upsellScrollEndTimer);
    });

    // abort dropdown listeners so rebuild after hard rerender is clean
    document.querySelectorAll("[data-upsell-dd]").forEach((dd) => {
      if (dd.__ddAbort) {
        try {
          dd.__ddAbort.abort();
        } catch (_) {}
        dd.__ddAbort = null;
      }
      dd.__ddSelectRef = null;
    });
  }

function isUpsellReady() {
  const roots = document.querySelectorAll(ROOT_SEL);
  if (!roots.length) return true;

  for (const root of roots) {
    const track = q(root, TRACK_SEL);
    if (!track) continue;

    // ready = є хоча б 2 реальні слайди + зібрані клони
    const realCount = track.__upsellRealCount || getRealSlides(track).length;
    if (realCount >= 2 && hasTwoClones(track)) continue;

    return false;
  }
  return true;
}

function reinitWithRetries() {
  resetAllTracks();

  let i = 0;
  const tick = () => {
    initAll();

    // якщо вже готово — НЕ робимо наступні тики
    if (isUpsellReady()) return;

    i += 1;
    if (i < REINIT_TRIES) setTimeout(tick, REINIT_DELAY);
  };

  tick();
}

  // money formatter (Shopify-like, minimal but sufficient)
  function formatMoney(cents, format) {
    const value = typeof cents === "string" ? cents.replace(".", "") : String(cents);
    const number = parseInt(value, 10);
    if (!Number.isFinite(number)) return "";

    function formatWithDelimiters(amount, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";

      const amt = (amount / 100).toFixed(precision);
      const parts = amt.split(".");
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? dollars + decimal + parts[1] : dollars;
    }

    const placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = placeholderMatch ? placeholderMatch[1] : "amount";

    let formatted = "";
    switch (placeholder) {
      case "amount":
        formatted = formatWithDelimiters(number, 2, ",", ".");
        break;
      case "amount_no_decimals":
        formatted = formatWithDelimiters(number, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        formatted = formatWithDelimiters(number, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formatted = formatWithDelimiters(number, 0, ".", ",");
        break;
      default:
        formatted = formatWithDelimiters(number, 2, ",", ".");
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function getMoneyFormatFromRoot(el) {
    const root = el.closest(ROOT_SEL);
    return root?.getAttribute("data-money-format") || "${{amount}}";
  }

  // ---------- NO-JUMP (clean): preserve only drawer scrollTop ----------
  function getDrawerScrollerFrom(el) {
    const root =
      el.closest(".m-cart-drawer") ||
      el.closest("[data-cart-drawer]") ||
      document.querySelector(".m-cart-drawer") ||
      document.querySelector("[data-cart-drawer]");

    if (!root) return null;

    return (
      root.querySelector(".m-cart-drawer__content") ||
      root.querySelector(".m-cart-drawer__body") ||
      root.querySelector(".m-cart-drawer__inner") ||
      root
    );
  }

  function preserveDrawerScroll(anchorEl, fn) {
    const scroller = getDrawerScrollerFrom(anchorEl);
    const top = scroller ? scroller.scrollTop : 0;

    const restore = () => {
      if (!scroller) return;
      scroller.scrollTop = top;
    };

    return Promise.resolve()
      .then(fn)
      .finally(() => {
        restore();
        requestAnimationFrame(restore);
        setTimeout(restore, 80);
        setTimeout(restore, 250);
        setTimeout(restore, 600);
      });
  }

  // =========================
  // Observers for rerenders (promo code / qty / section refresh)
  // =========================
  let __upsellMoTimer = null;

  function debounceSoftInit() {
    clearTimeout(__upsellMoTimer);
    __upsellMoTimer = setTimeout(() => {
      initAll();
    }, 80);
  }

  function startUpsellObserver() {
    const drawer =
      document.querySelector(".m-cart-drawer") || document.querySelector("[data-cart-drawer]");
    if (!drawer) return;

    if (drawer.__upsellObserver) return;

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList") continue;

        const nodes = [...m.addedNodes, ...m.removedNodes].filter((n) => n && n.nodeType === 1);

        const touchedUpsell =
          nodes.some((n) => n.matches?.(ROOT_SEL) || n.querySelector?.(ROOT_SEL)) ||
          nodes.some(
            (n) =>
              n.matches?.("[data-upsell-variant-select]") ||
              n.querySelector?.("[data-upsell-variant-select]")
          );

        if (touchedUpsell) {
          debounceSoftInit();
          break;
        }
      }
    });

    // ВАЖЛИВО: attributes НЕ слухаємо (інакше aria-expanded буде тригерити reinit)
    mo.observe(drawer, { childList: true, subtree: true });
    drawer.__upsellObserver = mo;
  }

  // якщо тема повністю замінює drawer — перевішуємо observer автоматично
  function startBodyWatcher() {
    if (document.body.__upsellBodyObserver) return;

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList") continue;
        const nodes = [...m.addedNodes].filter((n) => n && n.nodeType === 1);
        if (!nodes.length) continue;

        const drawerAdded = nodes.some(
          (n) =>
            n.matches?.(".m-cart-drawer") ||
            n.matches?.("[data-cart-drawer]") ||
            n.querySelector?.(".m-cart-drawer") ||
            n.querySelector?.("[data-cart-drawer]")
        );

        if (drawerAdded) {
          // дамо DOM дорендеритися
          setTimeout(() => {
            startUpsellObserver();
            initAll();
          }, 0);
          break;
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
    document.body.__upsellBodyObserver = mo;
  }

  // init
  document.addEventListener("DOMContentLoaded", () => {
    initAll();
    startUpsellObserver();
    startBodyWatcher();
  });

  // IMPORTANT: after add-to-cart rerender
  document.addEventListener("cart:refresh", () => setTimeout(reinitWithRetries, 0));
  document.documentElement.addEventListener("cart:refresh", () => setTimeout(reinitWithRetries, 0));

  // also ensure observers exist after refresh
  document.addEventListener("cart:refresh", () => setTimeout(startUpsellObserver, 0));
  document.documentElement.addEventListener("cart:refresh", () => setTimeout(startUpsellObserver, 0));

  // nav click
  document.addEventListener("click", (e) => {
    const prevBtn = e.target.closest(PREV_SEL);
    const nextBtn = e.target.closest(NEXT_SEL);
    if (!prevBtn && !nextBtn) return;

    const root = (prevBtn || nextBtn).closest(ROOT_SEL);
    const track = q(root, TRACK_SEL);
    if (!track) return;

    const n = track.__upsellRealCount || 0;
    if (n < 2) return;

    track.__upsellStep = getStep(track);

    const idx = getNearestIndex(track);
    const target = nextBtn ? idx + 1 : idx - 1;

    track.__upsellLock = true;
    goToIndex(track, target, true);

    afterScrollEnd(track, () => {
      normalizeIfOnClone(track);
      setScrollBehavior(track, "smooth");
      track.__upsellLock = false;
    });
  });

  // variant change: update button vid + price + image
  document.addEventListener("change", (e) => {
    const sel = e.target.closest("[data-upsell-variant-select]");
    if (!sel) return;

    const card = sel.closest(".m-cart-drawer-upsell__card");
    if (!card) return;

    const opt = sel.options[sel.selectedIndex];
    const vid = Number(opt.value);
    if (!vid) return;

    const btn = card.querySelector("[data-upsell-add]");
    if (btn) btn.setAttribute("data-vid", String(vid));

    const imageWrap = card.querySelector(".m-cart-drawer-item__image");
    const newSrc = opt.getAttribute("data-image");
    const newAlt = opt.getAttribute("data-image-alt") || "";

    if (imageWrap && newSrc) {
      imageWrap.querySelectorAll("picture, source, img").forEach((n) => n.remove());

      const target = imageWrap.querySelector("a") || imageWrap;

      const img = document.createElement("img");
      img.src = newSrc;
      img.alt = newAlt;
      img.loading = "lazy";
      img.decoding = "async";

      img.removeAttribute("srcset");
      img.removeAttribute("sizes");

      target.appendChild(img);
    }

    const priceWrap = card.querySelector("[data-upsell-price]");
    if (!priceWrap) return;

    const price = Number(opt.getAttribute("data-price") || 0);
    const compare = Number(opt.getAttribute("data-compare") || 0);
    const moneyFormat = getMoneyFormatFromRoot(sel);

    if (compare > price && compare > 0) {
      priceWrap.innerHTML =
        `<span class="m-cart-item__price--sale">${formatMoney(price, moneyFormat)}</span>` +
        `<span class="m-cart-item__price--compare">${formatMoney(compare, moneyFormat)}</span>`;
    } else {
      priceWrap.innerHTML =
        `<span class="m-cart-item__price--regular">${formatMoney(price, moneyFormat)}</span>`;
    }
  });

  // add to cart (NO JUMP + temporary "Added")
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-upsell-add]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    const vid = Number(btn.getAttribute("data-vid"));
    if (!vid) return;

    if (btn.__upsellBusy) return;
    btn.__upsellBusy = true;

    const originalText = btn.textContent;
    btn.disabled = true;

    // wrap label once
    let label = btn.querySelector(".upsell-btn__label");
    if (!label) {
      const span = document.createElement("span");
      span.className = "upsell-btn__label";
      span.textContent = originalText;
      btn.textContent = "";
      btn.appendChild(span);
      label = span;
    }

    // spinner once
    if (!btn.querySelector(".upsell-btn__spinner")) {
      const sp = document.createElement("span");
      sp.className = "upsell-btn__spinner";
      sp.setAttribute("aria-hidden", "true");
      btn.appendChild(sp);
    }

    btn.classList.add("is-loading");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: vid, quantity: 1 }),
      });

      if (!res.ok) throw new Error("Add to cart failed");

      btn.classList.remove("is-loading");
      btn.querySelector(".upsell-btn__label").textContent = "Added";

      await preserveDrawerScroll(btn, () => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        if (window.MinimogEvents?.publish) window.MinimogEvents.publish("cart:updated", {});
      });
    } catch (err) {
      console.error(err);
      btn.classList.remove("is-loading");
      btn.querySelector(".upsell-btn__label").textContent = "Error";
    } finally {
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.__upsellBusy = false;
      }, 2000);
    }
  });
})();